export type VoiceTokenResponse = {
  ok: boolean;
  token: string;
  modelId: string;
};

type ApiErrorPayload = {
  error?: string;
  detail?: string;
};

export type VoiceApiError = Error & {
  status?: number;
  code?: string;
};

export async function mintVoiceToken(): Promise<VoiceTokenResponse> {
  const response = await fetch("/api/voice/token", { method: "POST" });
  if (!response.ok) {
    let payload: ApiErrorPayload | null = null;
    try {
      payload = (await response.json()) as ApiErrorPayload;
    } catch {
      payload = null;
    }

    const error = new Error(
      payload?.detail || payload?.error || `Voice token failed (${response.status})`,
    ) as VoiceApiError;
    error.status = response.status;
    error.code = payload?.error;
    throw error;
  }

  const data = (await response.json()) as Partial<VoiceTokenResponse>;
  if (typeof data.token !== "string" || data.token.length === 0) {
    throw new Error("Voice token response was missing a token.");
  }

  return {
    ok: true,
    token: data.token,
    modelId:
      typeof data.modelId === "string" && data.modelId
        ? data.modelId
        : "scribe_v2_realtime",
  };
}
